import { render } from "./CharacterOwnList.vue?vue&type=template&id=2dba67b9&scoped=true&ts=true"
import script from "./CharacterOwnList.vue?vue&type=script&lang=ts"
export * from "./CharacterOwnList.vue?vue&type=script&lang=ts"

import "./CharacterOwnList.vue?vue&type=style&index=0&id=2dba67b9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dba67b9"]])

export default __exports__